export default () => ({
  integrations: [],
  integration: null,
  totalIntegrations: 0,
  searchTerm: '',
  pageSize: 10,
  sortDir: 'asc',
  orderBy: 'Name',
  status: '',
  filterBy: 0
})



// WEBPACK FOOTER //
// ./src/store/modules/integrations/state.js